export const queuesPaths = {
    new: "new",
    edit: ":queueId",
} as const;
